/**
 * Checklist popover for picking any subset of clinics.
 * `clinics` is [{ id, displayName }]; `selected` is an array of ids.
 */

import { useState } from 'react'
import { ChevronDown } from 'lucide-react'
import { Button, Checkbox, Popover, PopoverTrigger, PopoverContent } from './ui'

export default function ClinicMultiSelect({ clinics, selected, onChange, label = 'Clinics' }) {
  const [open, setOpen] = useState(false)
  const allIds = clinics.map((c) => c.id)
  const toggle = (id) =>
    onChange(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id])
  return (
    <div className="space-y-1">
      <label className="text-xs font-medium text-muted-foreground">{label}</label>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="w-full sm:w-56 justify-between font-normal">
            <span>{selected.length} of {clinics.length} selected</span>
            <ChevronDown className="w-4 h-4 opacity-60" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-56 p-2" align="start">
          <div className="flex justify-between px-1 pb-2 mb-1 border-b">
            <button className="text-xs text-primary hover:underline" onClick={() => onChange(allIds)}>Select all</button>
            <button className="text-xs text-muted-foreground hover:underline" onClick={() => onChange([])}>Clear</button>
          </div>
          <div className="max-h-64 overflow-y-auto space-y-0.5">
            {clinics.map((c) => (
              <label key={c.id} className="flex items-center gap-2 px-1 py-1.5 rounded hover:bg-accent cursor-pointer text-sm">
                <Checkbox checked={selected.includes(c.id)} onCheckedChange={() => toggle(c.id)} />
                <span className="truncate">{c.displayName || c.id}</span>
              </label>
            ))}
          </div>
        </PopoverContent>
      </Popover>
    </div>
  )
}
